import { Listing } from "storefront/Listing";
import { GrailedAPIHeavyListing } from "storefront/Listing/GrailedAPIHeavyListing";

/**
 * @name soldPriceWithShipping
 * @description Add shipping back to sold price. ONLY for use in our Analytics events
 */
const soldPriceWithShipping = (
  listing: Listing | GrailedAPIHeavyListing,
): number =>
  listing.soldPriceIncludesShipping
    ? listing.soldPrice
    : listing.soldPrice + (listing.soldShippingPrice || 0);

export default soldPriceWithShipping;
